import { useQuery, UseQueryResult } from 'react-query'

interface IUseQueryHookProps<T> {
  key: string | Array<string>
  fetcherFunction: (...args: any[]) => Promise<T>
}

export function useQueryHook<T>({ key, fetcherFunction }: IUseQueryHookProps<T>): UseQueryResult<T> {
  const queryObject = useQuery<T>(key, () => fetcherFunction(), {
    retry: 0,
  })

  return queryObject
}
